module.exports = "/assets/festival-banners/listing-banner-bw.png?E11WBPY";